import useAxios from 'axios-hooks';
import { ESG_PLAN } from './Esg/EsgPlan';

export interface IProgress {
  report: IReportDetails;
  cgrScore: ICGRScore | null;
  businessOperation: IBusinessOperation;
  goalsAndOperationalPlans: IGoalsAndOperationalPlans;
  esgPlans: IESGDetails;
  summarizeReport: ISummarizeReport;
}

export interface IReportDetails {
  id: number;
  startOperatingYear: number;
  endOperatingYear?: number;
  companyId: number;
  documentTh: string;
  documentEn: string;
}

export interface ICGRScore {
  score: number;
  updateDate: string;
  year: number;
}

export interface IBusinessOperation {
  natureOfBusiness: ISectionCompletion;
  impactsOnStakeholdersManagement: ISectionCompletion;
  financialStatements: ISectionCompletion;
}

export interface IGoalsAndOperationalPlans {
  goalsOperationalPlansAndRiskManagement: ISectionCompletion;
}

export interface IESGDetails {
  characteristicTypes: ESG_PLAN[];
  esgDataPlatform?: ISectionCompletion;
  greenhouse?: ISectionCompletion;
}

export interface IESGPlatform {
  isSectionCompletedTh: boolean;
  isSectionCompletedEn: boolean;
}

export interface ISummarizeReport {
  committeeApprovalDate: Date | null;
  publishedDate: Date | null;
  isDraftReport: boolean;
}

export interface ISectionCompletion {
  completionPercentage: number;
  isSectionCompletedTh: boolean;
  isSectionCompletedEn: boolean;
  updateDate?: string;
}

export const useGetProgress = (
  id: number,
  companyId: string,
  isUpdate?: boolean
) => {
  const updateSummarizeFlag = isUpdate ? `&isUpdate=${isUpdate}` : '';

  return useAxios<IProgress>({
    url: `/progress/${id}?companyId=${companyId}${updateSummarizeFlag}`,
    method: 'GET',
  });
};
